// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as UnsubscribeActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import UnsubscribeSuccess from '../components/UnsubscribeSuccess';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    authenticated: state.auth.authenticated,
    user: state.auth.user,
    isSubscribing: state.unsubscribe.isSubscribing,
    subscribeError: state.unsubscribe.error,
    subscribeSuccess: state.unsubscribe.subscribeSuccess,
  };
}

function mapDispatchToProps(dispatch: Function) {
  const bindedActions = bindActionCreators({
    ...UnsubscribeActions, ...AlertActions
  }, dispatch);
  return { ...bindedActions, dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(UnsubscribeSuccess);



// WEBPACK FOOTER //
// ./src/modules/unsubscribe/containers/UnsubscribeSuccessContainer.js